export let tag_post = [
    {
        id:1,
        title:'آشپزی'
    },
    {
        id:2,
        title:'فست فود'
    },
    {
        id:3,
        title:'سبزیجات'
    },
    {
        id:4,
        title:'سالاد'
    },
    {
        id:5,
        title:'میوه'
    },
    {
        id:6,
        title:'عذای سالم'
    },
    {
        id:7,
        title:'دستور پخت'
    }
];